module.exports = __webpack_public_path__ + "img/locale-icon.21dcc804.svg";